import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";

const NAME = (
  <>
    <TooltipModalTitle>Name your scan</TooltipModalTitle>
    <TooltipModalBody align="start">
      A unique, human-readable name for this scan. Use it to identify the scan across the Cloud
      scanning list and dashboards — for example the cloud account or environment you&apos;re
      checking for unmanaged resources.
    </TooltipModalBody>
  </>
);

const SPACE = (
  <>
    <TooltipModalTitle>Choose a space</TooltipModalTitle>
    <TooltipModalBody align="start">
      The space this scan belongs to. Access to the scan and the resources it discovers follows the
      permissions of the selected space.
    </TooltipModalBody>
  </>
);

const LABELS = (
  <>
    <TooltipModalTitle>Add labels</TooltipModalTitle>
    <TooltipModalBody align="start">
      Optional labels to organize and filter your scans — for example by team, environment, or cloud
      account.
    </TooltipModalBody>
  </>
);

const DESCRIPTION = (
  <>
    <TooltipModalTitle>Describe your scan</TooltipModalTitle>
    <TooltipModalBody align="start">
      An optional, human-friendly description of what this scan covers and why. Only used to make it
      easier for you and your team to understand the scan&apos;s purpose.
    </TooltipModalBody>
  </>
);

const PROVIDER_VERSION = (
  <>
    <TooltipModalTitle>Provider version</TooltipModalTitle>
    <TooltipModalBody align="start">
      The AWS Terraform provider version used to run the scan. It determines which resource types
      can be discovered in your account.
    </TooltipModalBody>
  </>
);

const INTEGRATION = (
  <>
    <TooltipModalTitle>Integration</TooltipModalTitle>
    <TooltipModalBody align="start">
      The AWS cloud integration whose credentials are used to authenticate and read resources during
      the scan. It defines which account is scanned.
    </TooltipModalBody>
  </>
);

const tooltips = {
  NAME,
  SPACE,
  LABELS,
  DESCRIPTION,
  PROVIDER_VERSION,
  INTEGRATION,
};

export default tooltips;
